import { userDomain, userStore } from '@user';
import { useRecoilValue } from 'recoil';

export const useCurrentUser = () => {
  return useRecoilValue(userStore.userState) as userDomain.User;
};
